import request from 'request-promise';
import config from '../config/config';

export class IdentityRequest {

    ERROR_RESPONSE = 'ERROR';
    SUCCESS_RESPONSE = 'OK';

    init = async (code, password, resumeToken) => {
        const headers = {
            'Content-Type': 'application/json',
            'x-api-key': config.identity_api_key
        };
        const body = {
            code: code,
            password: password || "",
        };
        if (resumeToken) {
            body.resumeToken = resumeToken;
        }
        const options = {
            url: `${config.identity_api_url}/identity/login`,
            method: 'POST',
            headers: headers,
            json: true,
            timeout: 60000,
            body,
        };
        const result = await request(options);
        return result;
    };

    getPlates = async (token, code) => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token,
            'x-api-key': config.identity_api_key
        };
        const options = {
            url: `${config.identity_api_url}/identity/multiple/${code}/plates`,
            method: 'GET',
            headers: headers,
            json: true,
            timeout: 60000,
        };
        const result = await request(options);
        return result;
    };

    getResume = async (token, qs) => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token,
            'x-api-key': config.identity_api_key
        };
        const options = {
            url: `${config.identity_api_url}/identity/resume`,
            method: 'GET',
            headers: headers,
            json: true,
            timeout: 60000,
            qs: qs
        };
        const result = await request(options);
        return result;
    };

    getStep = async (code, token) => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token,
            'x-api-key': config.identity_api_key
        };

        const options = {
            url: `${config.identity_api_url}/identity/${code}/step`,
            method: 'GET',
            json: true,
            headers: headers,
            timeout: 60000,
        };
        const result = await request(options);
        return result;
    };

    postStep = async (code, token, body) => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token,
            'x-api-key': config.identity_api_key
        };
        const options = {
            url: `${config.identity_api_url}/identity/${code}/step`,
            method: 'POST',
            headers: headers,
            timeout: 60000,
            json: true,
            body: body
        };
        const result = await request(options);
        return result;
    };

    getProcessData = async (code) => {
        const headers = {
            'Content-Type': 'application/json',
            'x-api-key': config.identity_api_key
        };
        const options = {
            url: `${config.identity_api_url}/identity/${code}/review`,
            method: 'GET',
            headers: headers,
            timeout: 60000,
            json: true,
        };
        const result = await request(options);
        return result;
    };

    saveError = async (code, errorCode, title, description) => {
        const headers = {
            'Content-Type': 'application/json',
            'x-api-key': config.identity_api_key
        };
        const options = {
            url: `${config.identity_api_url}/identity/error`,
            method: 'POST',
            headers: headers,
            json: true,
            timeout: 60000,
            body: {
                code,
                errorCode,
                title,
                description,
            }
        };
        const result = await request(options);
        return result;
    };
}

export default new IdentityRequest();
